(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio-custom-order"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('studio-custom-order')) {
  customElements.define('studio-custom-order', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.messages = this.querySelector('[data-messages]').dataset;
      this.objectUrls = [];
      this.originalArtwork = {};
      this.processingArtwork = new Set();
      this.artworkVersion = {};
      this.shirtPhotos = {"garment|front": "https://cdn.shopify.com/s/files/1/0785/4299/5688/files/studio-row-garment-seamless-mockup.png?v=1793756208", "garment|back": "https://cdn.shopify.com/s/files/1/0785/4299/5688/files/studio-row-verified-garment-back.png?v=1793754993", "cropped|front": "https://cdn.shopify.com/s/files/1/0785/4299/5688/files/studio-row-verified-cropped-front.png?v=1793754984", "cropped|back": "https://cdn.shopify.com/s/files/1/0785/4299/5688/files/studio-row-verified-cropped-back.png?v=1793754989", "classic|front": "https://cdn.shopify.com/s/files/1/0785/4299/5688/files/studio-row-classic-seamless-mockup.png?v=1793756212", "classic|back": "https://cdn.shopify.com/s/files/1/0785/4299/5688/files/studio-row-verified-classic-back.png?v=1793754998", "baby|Black|front": "https://cdn.shopify.com/s/files/1/0785/4299/5688/files/studio-row-baby-black-seamless-mockup.png?v=1793756222", "baby|Black|back": "https://cdn.shopify.com/s/files/1/0785/4299/5688/files/studio-row-baby-rib-black-back.png?v=1793755309", "baby|Bone|front": "https://cdn.shopify.com/s/files/1/0785/4299/5688/files/studio-row-baby-bone-seamless-mockup.png?v=1793756197", "baby|Bone|back": "https://cdn.shopify.com/s/files/1/0785/4299/5688/files/studio-row-baby-rib-bone-back.png?v=1793755324", "baby|Heather Grey|front": "https://cdn.shopify.com/s/files/1/0785/4299/5688/files/studio-row-baby-heather-grey-seamless-mockup.png?v=1793756218", "baby|Heather Grey|back": "https://cdn.shopify.com/s/files/1/0785/4299/5688/files/studio-row-baby-rib-heather-grey-back.png?v=1793755329", "baby|Navy|front": "https://cdn.shopify.com/s/files/1/0785/4299/5688/files/studio-row-baby-navy-seamless-mockup.png?v=1793756228", "baby|Navy|back": "https://cdn.shopify.com/s/files/1/0785/4299/5688/files/studio-row-baby-rib-navy-back.png?v=1793755334"};
      this.palette = {
        baby: {'Bone':'#f1e9d8','Black':'#101820','Heather Grey':'#97999b','Navy':'#13294b'},
        garment: {'Black':'#26252a','White':'#f7f6f5','True Navy':'#21354e','Espresso':'#816655','Moss':'#637865','Chili':'#a23243'},
        cropped: {'Black':'#151213','White':'#f7f7f5','Off White':'#f1eee7','Off Black':'#342a2c'},
        classic: {'Black':'#131919','White':'#f7f7f5','Cream':'#f8e9cf','Navy':'#14263e'}
      };
      this.measurements = {
        baby: {width:[13.5,14.5,15.5,16.5,17.5],length:[17.5,18,18.5,19,19.5]},
        garment: {width:[18.25,20.25,22,24,26,27.75],length:[26.6,28,29.4,30.75,31.6,32.5]},
        cropped: {width:[20,22,24,26,28],length:[26,27,27.5,29,31]},
        classic: {width:[18,20,22,24,26,28],length:[27,29,31,32,33,34]}
      };
      this.styles = {
        baby: {prefix:'Baby Rib: ',colors:['Bone','Black','Heather Grey','Navy']},
        garment: {prefix: '', colors: ['Black','White','True Navy','Espresso','Moss','Chili']},
        cropped: {prefix: 'Cropped: ', colors: ['Black','White','Off White','Off Black']},
        classic: {prefix: 'Classic: ', colors: ['Black','White','Cream','Navy']}
      };
      const initial = this.variants.find(v => String(v.id) === new URLSearchParams(location.search).get('variant')) || this.variants.find(v => String(v.id) === this.querySelector('[data-variant]').value) || this.variants[0];
      if (initial) {
        const key = initial.options[0].startsWith('Baby Rib: ') ? 'baby' : initial.options[0].startsWith('Cropped: ') ? 'cropped' : initial.options[0].startsWith('Classic: ') ? 'classic' : 'garment';
        this.querySelector('[data-style]').value = key;
        this.syncChoices(initial.options[0].replace(this.styles[key].prefix, ''), initial.options[1]);
        this.querySelector('[data-option="2"]').value = initial.options[2];
      } else this.syncChoices();
      const requestedStyle=new URLSearchParams(location.search).get('style');
      if(this.styles[requestedStyle]){this.querySelector('[data-style]').value=requestedStyle;this.syncChoices();}
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-style-choice],[data-swatch],[data-size-choice],[data-print-choice]');
        if (button) {
          const target = button.hasAttribute('data-style-choice') ? this.querySelector('[data-style]') : button.hasAttribute('data-swatch') ? this.querySelector('[data-color]') : button.hasAttribute('data-size-choice') ? this.querySelector('[data-option="1"]') : this.querySelector('[data-option="2"]');
          target.value = button.dataset.styleChoice || button.dataset.swatch || button.dataset.sizeChoice || button.dataset.printChoice;
          target.dispatchEvent(new Event('change', {bubbles:true}));
        }
        if (event.target.closest('[data-open-fit]')) {
          event.preventDefault();
          const guide = this.querySelector('.sr-fit-guide'); guide.open = true;
          guide.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'nearest'});
        }
      });
      const compactMedia=matchMedia('(max-width: 800px)');
      const placePreview=()=>{
        const preview=this.querySelector('.sr-sticky-preview');
        const original=this.querySelector('.sr-custom__intro');
        if(compactMedia.matches){this.form.querySelector('.sr-form-section').after(preview);original.hidden=true;}
        else{original.append(preview);original.hidden=false;}
      };
      compactMedia.addEventListener('change',placePreview);placePreview();
      this.form.addEventListener('change', async (event) => {
        if (event.target.matches('[data-artwork]')) await this.prepareArtwork(event.target.dataset.artwork, true);
        if (event.target.matches('[data-remove-background]')) await this.prepareArtwork(event.target.dataset.removeBackground, false);
        if (event.target.matches('[data-style],[data-color]')) this.syncChoices();
        if (event.target.matches('[name="properties[Front placement]"]')) {
          const chest = event.target.value === this.querySelector('[name="properties[Front placement]"]').options[1].value;
          this.querySelector('[data-scale="front"]').value = chest ? '3.5' : '11';
          this.querySelector('[data-top="front"]').value = chest ? '2.5' : '2.5';
        }
        this.update();
        this.preview();
        if (event.target.matches('[data-artwork]') && !event.target.disabled) this.showView(event.target.dataset.artwork);
      });
      this.form.addEventListener('input', () => this.update());
      this.querySelectorAll('[data-view]').forEach(button => button.addEventListener('click', () => this.showView(button.dataset.view)));
      this.querySelectorAll('[data-scale],[data-top]').forEach(input => input.addEventListener('input', () => this.positionArtwork()));
      this.showView('front');
      this.dispatchEvent(new CustomEvent('studio:builder_viewed',{bubbles:true}));
      this.form.addEventListener('submit', (event) => {
        this.update();
        if (!this.form.reportValidity() || this.querySelector('[data-submit]').disabled) event.preventDefault();
        else this.dispatchEvent(new CustomEvent('studio:cart_submitted',{bubbles:true,detail:{style:this.querySelector('[data-style]').value,variant_id:this.querySelector('[data-variant]').value,quantity:Number(this.form.elements.quantity.value)}}));
      });
      this.update();
    }
    disconnectedCallback() { (this.objectUrls || []).forEach(url => URL.revokeObjectURL(url)); }
    syncChoices(preferredColor, preferredSize) {
      const key = this.querySelector('[data-style]').value;
      const style = this.styles[key];
      const color = this.querySelector('[data-color]');
      const previousColor = preferredColor || color.value;
      const colors = style.colors.filter(c => this.variants.some(v => v.options[0] === style.prefix + c));
      color.replaceChildren(...colors.map(c => new Option(c, c)));
      if (colors.includes(previousColor)) color.value = previousColor;
      const combined = style.prefix + color.value;
      this.querySelector('[data-option="0"]').replaceChildren(new Option(combined, combined));
      const size = this.querySelector('[data-option="1"]');
      const previousSize = preferredSize || size.value;
      const sizes = ['S','M','L','XL','2XL','3XL'].filter(s => this.variants.some(v => v.options[0] === combined && v.options[1] === s));
      size.replaceChildren(...sizes.map(s => new Option(s, s)));
      if (sizes.includes(previousSize)) size.value = previousSize;
      this.querySelector('[data-style-description]').textContent = this.messages[key + 'Description'];
    }
    update() {
      const options = [...this.querySelectorAll('[data-option]')].map(input => input.value);
      const variant = this.variants.find(item => item.options.every((value, index) => value === options[index]));
      const back = this.querySelector('[data-artwork="back"]');
      const hasBack = options[2] === 'Front + Back';
      this.querySelector('[data-back-wrap]').hidden = !hasBack;
      back.disabled = !hasBack;
      back.required = hasBack;
      this.querySelector('[data-view="back"]').hidden = !hasBack;
      const color = this.querySelector('[data-color]').value;
      const style = this.querySelector('[data-style]').value;
      const hex = this.palette[style][color] || '#ffffff';
      const channels = style==='baby' ? [1,1,1] : [1,3,5].map(i => parseInt(hex.slice(i,i+2),16) / 235);
      const [r,g,b] = channels;
      this.querySelector('[data-tint-matrix]').setAttribute('values', `${r} 0 0 0 0 0 ${g} 0 0 0 0 0 ${b} 0 0 0 0 0 1 0`);
      this.querySelectorAll('.sr-mockup__shirt').forEach(shirt => {
        shirt.style.filter = 'url(#' + this.dataset.tintFilter + ')';
        const geometry = this.shirtGeometry();
        shirt.style.top = '0';
        shirt.style.height = '100%';
        shirt.style.clipPath = 'none';
        const side=shirt.closest('[data-stage]').dataset.stage;
        const image=shirt.querySelector('img');
        const source=this.shirtPhotos[style==='baby'?'baby|'+color+'|'+side:style+'|'+side];
        if(image.getAttribute('src')!==source)image.src=source;
      });
      if (!hasBack && this.querySelector('[data-panel="front"]').hidden) this.showView('front');
      for (const side of ['front','back']) {
        const input = this.querySelector('[data-artwork="' + side + '"]');
        const file = input.files[0];
        const showControls = !input.disabled && file && /\.(png|jpe?g)$/i.test(file.name);
        this.querySelector('[data-controls="' + side + '"]').hidden = !showControls;
        this.querySelector('[data-scale="' + side + '"]').disabled = !showControls;
        this.querySelector('[data-top="' + side + '"]').disabled = !showControls;
        this.querySelector('[data-print-height="' + side + '"]').disabled = !showControls;
      }
      this.renderChoices();
      this.positionArtwork();
      for (const input of this.querySelectorAll('[data-artwork]')) {
        const file = input.files[0];
        const invalid = !input.disabled && file && (!/\.(png|jpe?g|pdf)$/i.test(file.name) || file.size > 20 * 1024 * 1024 || file.size === 0);
        input.setCustomValidity(invalid ? this.messages.invalid : '');
      }
      const enabledArtwork=[...this.querySelectorAll('[data-artwork]')].filter(input=>!input.disabled);
      const artworkReady=enabledArtwork.every(input=>input.files.length&&input.validity.valid)&&this.processingArtwork.size===0;
      const summary=this.querySelector('[data-review-summary]');
      if(summary){summary.textContent=[this.querySelector('[data-style] option:checked').textContent,this.querySelector('[data-color]').value,this.querySelector('[data-option="1"]').value,this.querySelector('[data-option="2"] option:checked').textContent].join(' · ');const art=this.querySelector('[data-review-art]');art.textContent=artworkReady?art.dataset.readyText:art.dataset.waitingText;this.querySelector('[data-progress-art]').dataset.complete=String(artworkReady);this.querySelector('[data-progress-order]').dataset.complete=String(artworkReady&&!!variant&&variant.available);}
      if(artworkReady&&!this.wasArtworkReady)this.dispatchEvent(new CustomEvent('studio:design_ready',{bubbles:true,detail:{style:this.querySelector('[data-style]').value,back:enabledArtwork.length===2}}));
      this.wasArtworkReady=artworkReady;
      const button = this.querySelector('[data-submit]');
      button.disabled = !variant || !variant.available || this.processingArtwork.size > 0;
      button.textContent = this.processingArtwork.size ? this.messages.processing : button.disabled ? this.messages.unavailable : this.messages.add;
      this.querySelector('[data-variant]').value = variant ? variant.id : '';
      const quantity = Number(this.form.elements.quantity.value);
      if (variant) {
        this.querySelector('[data-total]').textContent = quantity === 1 ? variant.formatted : new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:'USD'}).format(variant.price * (Number.isInteger(quantity) && quantity > 0 ? quantity : 1) / 100);
      }
    }

    showView(side) {
      if (side === 'back' && this.querySelector('[data-artwork="back"]').disabled) side = 'front';
      this.querySelectorAll('[data-panel]').forEach(panel => { panel.hidden = panel.dataset.panel !== side; });
      this.querySelectorAll('[data-view]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.view === side)));
    }
    shirtGeometry(side='front') {
      const style=this.querySelector('[data-style]').value;
      const size=this.querySelector('[data-option="1"]').value;
      const i=['S','M','L','XL','2XL','3XL'].indexOf(size);
      const width=this.measurements[style].width[i]||20;
      const length=this.measurements[style].length[i]||28;
      const reference={baby:{body:47,front:26,back:18,hem:87.5,span:75},garment:{body:52,front:18.5,back:11.5,hem:92.5,span:85},cropped:{body:44,front:19.5,back:15.5,hem:88,span:76},classic:{body:50,front:18,back:11.5,hem:92.5,span:85}}[style];
      return {style,width,length,height:100,top:0,unit:reference.body/width,verticalUnit:reference.span/length,neckline:reference[side],hem:reference.hem,center:50,bodyWidth:reference.body};
    }
    renderChoices() {
      const style = this.querySelector('[data-style]').value;
      const color = this.querySelector('[data-color]').value;
      const size = this.querySelector('[data-option="1"]').value;
      const container = this.querySelector('[data-swatches]');
      if (container.dataset.style !== style) {
        container.replaceChildren(...this.styles[style].colors.map(name => {
          const button = document.createElement('button'); button.type='button'; button.dataset.swatch=name;
          button.style.setProperty('--sr-swatch',this.palette[style][name]);button.setAttribute('aria-label',name);button.title=name;
          return button;
        }));container.dataset.style=style;
        const sizes = [...this.querySelector('[data-option="1"]').options].map(o=>o.value);
        this.querySelector('[data-sizes]').replaceChildren(...sizes.map(name=>{const button=document.createElement('button');button.type='button';button.dataset.sizeChoice=name;button.textContent=name;return button;}));
      }
      this.querySelectorAll('[data-swatch]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.swatch===color)));
      this.querySelectorAll('[data-size-choice]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.sizeChoice===size)));
      this.querySelectorAll('[data-style-choice]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.styleChoice===style)));
      this.querySelectorAll('[data-print-choice]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.printChoice===this.querySelector('[data-option="2"]').value)));
      this.querySelector('[data-color-name]').textContent=color;
      this.querySelector('[data-preview-caption]').textContent=color+' / '+size;
      this.querySelector('[data-measurement-description]').textContent=this.messages[style+'Description'];
      const names=['S','M','L','XL','2XL','3XL'];
      this.querySelector('[data-size-table]').replaceChildren(...this.measurements[style].width.map((width,i)=>{
        const row=document.createElement('tr');row.setAttribute('aria-current',String(names[i]===size));
        [names[i],width+' in',this.measurements[style].length[i]+' in'].forEach(value=>{const cell=document.createElement('td');cell.textContent=value;row.append(cell);});return row;
      }));
    }
    positionArtwork() {
      const placement=this.querySelector('[name="properties[Front placement]"]');
      const showArea=this.querySelector('[data-show-print-area]').checked;
      for(const side of ['front','back']) {
        const geometry=this.shirtGeometry(side);
        const print=this.querySelector('[data-print="'+side+'"]');
        const widthInput=this.querySelector('[data-scale="'+side+'"]');
        const topInput=this.querySelector('[data-top="'+side+'"]');
        const chest=side==='front' && placement.selectedIndex===1;
        const ratio=print.naturalWidth>0 && print.naturalHeight>0 ? print.naturalWidth/print.naturalHeight : 1;
        const top=Number(topInput.value)||2.5;
        const maxHeight=Math.max(0.1,Math.min(geometry.style==='baby'?12:19.6,geometry.length-(geometry.style==='baby'?3:5)-top,(geometry.hem-geometry.neckline-top*geometry.verticalUnit-1)/geometry.unit));
        const maxWidth=Math.min(chest?4.5:geometry.style==='baby'?9:16,geometry.width-3,maxHeight*ratio);
        widthInput.min=String(Math.min(1.5,maxWidth));widthInput.max=String(maxWidth);widthInput.step='any';
        if(Number(widthInput.value)>Number(widthInput.max))widthInput.value=widthInput.max;
        const width=Number(widthInput.value)||Math.min(11,maxWidth),height=width/ratio;
        topInput.max=String(Math.max(0.5,Math.min(8,geometry.length-(geometry.style==='baby'?3:5)-height)));
        if(Number(topInput.value)>Number(topInput.max))topInput.value=topInput.max;
        const finalTop=Number(topInput.value);
        print.style.width=(width*geometry.unit)+'%';
        print.style.top=(geometry.neckline+finalTop*geometry.verticalUnit)+'%';
        print.style.left=(geometry.center+(chest?geometry.bodyWidth*.22:0))+'%';
        this.querySelector('[data-print-height="'+side+'"]').value=height.toFixed(2);
        this.querySelector('[data-dimensions="'+side+'"]').textContent=width.toFixed(2)+' × '+height.toFixed(2)+' in';
        this.querySelector('[data-empty="'+side+'"]').hidden=!print.hidden;
        const area=this.querySelector('[data-print-area="'+side+'"]');
        area.hidden=!showArea;area.style.width=(Math.min(chest?4.5:geometry.style==='baby'?9:16,geometry.width-3)*geometry.unit)+'%';area.style.height=(maxHeight*geometry.unit)+'%';area.style.top=print.style.top;area.style.left=print.style.left;
      }
      this.querySelector('[data-print-limit]').textContent=this.querySelector('[data-style]').value==='baby'?this.messages.babyLimit:this.messages.limitCopy;
    }
    removeBackgroundPixels(pixels, width, height) {
      const count=width*height,edge=[];
      for(let x=0;x<width;x++){edge.push(x,(height-1)*width+x)}
      for(let y=1;y<height-1;y++){edge.push(y*width,y*width+width-1)}
      const opaque=edge.filter(i=>pixels[i*4+3]>240);
      if(opaque.length<edge.length*.3)return 0;
      const buckets=new Map();
      for(const i of opaque){const p=i*4;const key=[0,1,2].map(c=>Math.floor(pixels[p+c]/24)).join(',');let b=buckets.get(key);if(!b){b={n:0,r:0,g:0,b:0};buckets.set(key,b)}b.n++;b.r+=pixels[p];b.g+=pixels[p+1];b.b+=pixels[p+2]}
      const dominant=[...buckets.values()].sort((a,b)=>b.n-a.n)[0];
      if(!dominant||dominant.n<opaque.length*.22)throw new Error('Background is not a solid color');
      const bg=[dominant.r/dominant.n,dominant.g/dominant.n,dominant.b/dominant.n];
      const seen=new Uint8Array(count),queue=new Uint32Array(count);let head=0,tail=0,changed=0;
      const visit=index=>{if(seen[index])return;seen[index]=1;const p=index*4;const delta=[0,1,2].map(c=>Math.abs(pixels[p+c]-bg[c]));if(pixels[p+3]===0||(Math.max(...delta)<=45&&delta.reduce((n,x)=>n+x*x,0)<=3*30*30))queue[tail++]=index;};
      edge.forEach(visit);
      while(head<tail){const i=queue[head++],p=i*4;if(pixels[p+3]){pixels[p+3]=0;changed++}const x=i%width;if(x>0)visit(i-1);if(x<width-1)visit(i+1);if(i>=width)visit(i-width);if(i<count-width)visit(i+width)}
      return changed;
    }
    async prepareArtwork(side, newUpload) {
      const input = this.querySelector('[data-artwork="' + side + '"]');
      const checkbox = this.querySelector('[data-remove-background="' + side + '"]');
      this.querySelector('[data-background-error="' + side + '"]').hidden = true;
      if (newUpload) this.originalArtwork[side] = input.files[0];
      const original = this.originalArtwork[side];
      const png = original && /\.png$/i.test(original.name);
      this.querySelector('[data-remove-wrap="' + side + '"]').hidden = !png;
      const property = this.querySelector('[data-background-result="' + side + '"]');
      property.value = 'No';
      const version = (this.artworkVersion[side] || 0) + 1;
      this.artworkVersion[side] = version;
      if (!original || !png || original.size > 20*1024*1024 || original.size === 0) { this.processingArtwork.delete(side); this.update(); return; }
      this.processingArtwork.add(side);
      this.update();
      const replaceFile = (file) => { const transfer = new DataTransfer(); transfer.items.add(file); input.files = transfer.files; };
      try {
        if (!checkbox.checked) { replaceFile(original); return; }
        const bitmap = await createImageBitmap(original);
        try {
          if (bitmap.width * bitmap.height > 16000000) throw new Error('Image too large');
          const canvas = document.createElement('canvas');
          canvas.width = bitmap.width; canvas.height = bitmap.height;
          const context = canvas.getContext('2d', {willReadFrequently:true});
          context.drawImage(bitmap, 0, 0);
          const image = context.getImageData(0, 0, canvas.width, canvas.height);
          const changed = this.removeBackgroundPixels(image.data, canvas.width, canvas.height);
          if (this.artworkVersion[side] !== version) return;
          if (!changed) { replaceFile(original); return; }
          context.putImageData(image, 0, 0);
          const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'));
          if (!blob) throw new Error('PNG encoding failed');
          if (this.artworkVersion[side] !== version) return;
          if (blob.size > 20*1024*1024) throw new Error('PNG too large');
          replaceFile(new File([blob], original.name.replace(/\.png$/i,'-transparent.png'), {type:'image/png',lastModified:original.lastModified}));
          property.value = 'Yes';
        } finally { bitmap.close(); }
      } catch (error) {
        if (this.artworkVersion[side] === version) {
          checkbox.checked = false;
          try { replaceFile(original); } catch (restoreError) {}
          this.querySelector('[data-status="' + side + '"]').textContent = this.messages.backgroundError;
          checkbox.title = this.messages.backgroundError;
          this.querySelector('[data-background-error="' + side + '"]').hidden = false;
        }
      } finally {
        if (this.artworkVersion[side] === version) {
          this.processingArtwork.delete(side);
          this.update();
          this.preview();
        }
      }
    }
    preview() {
      this.objectUrls.forEach(url => URL.revokeObjectURL(url));
      this.objectUrls = [];
      for (const side of ['front','back']) {
        const input = this.querySelector('[data-artwork="' + side + '"]');
        const file = input.files[0];
        const print = this.querySelector('[data-print="' + side + '"]');
        const status = this.querySelector('[data-status="' + side + '"]');
        print.hidden = true;
        print.removeAttribute('src');
        if (input.disabled || !file) { status.textContent = this.messages.uploadPrompt; continue; }
        if (!input.validity.valid) { status.textContent = this.messages.invalid; continue; }
        if (!/\.(png|jpe?g)$/i.test(file.name)) { status.textContent = this.messages.pdfNote + ' ' + file.name; continue; }
        const url = URL.createObjectURL(file);
        this.objectUrls.push(url);
        print.onload = () => this.positionArtwork();
        print.src = url;
        print.hidden = false;
        status.textContent = file.name;
        print.onerror = () => { print.hidden = true; status.textContent = this.messages.invalid; };
      }
      this.positionArtwork();
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
